import styled from "styled-components";
import ArticleList from "../../components/contents/board/ArticleList";
import PageTemplate from "../../components/ui/common/template/PageTemplate";
import CenterDiv from "../../style/styled-components/components/CenterDiv";
import ContentDiv from "../../style/styled-components/components/ContentDiv";
import { useArticles } from "../../components/hooks/useArticles";
const Board2Page = () => {
  const articlelist = useArticles("customsnews");
  return (
    <PageTemplate title="관세무역 뉴스" noImage>
      <CenterDiv>
        <ContentDiv>
          <Div>
            <ArticleList
              category="customsnews"
              contents={articlelist}
            />
          </Div>
        </ContentDiv>
      </CenterDiv>

    </PageTemplate>
  );
};
export default Board2Page;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2.5rem;
`;
